<template>
  <div>
    <div class="mt-5 text-center w-100" v-if="isLoading">
      <HMSpinner/>
    </div>
    <StudioPurchaseToolbar
      v-if="bundle"
      :product="bundle"
      :isBundleToolbar="review"
      :showFullActions="showFullActions"
      :isPurchasing="isPurchasing"
    />
    <div class="container" v-if="bundle">
      <div class="mt-5">
        <HMStudioBackButton
          v-if="bundle.product_name"
          :backText="`${this.$t('GENERAL.TEXT.BACK_TO')} ${
            bundle.product_name
          }`"
        />
      </div>
      <Product :review="true" class="mt-2" prefix="bundle-" />
    </div>
  </div>
</template>

<script lang="ts">
import { useProductStore } from '@/stores';
import Product from '@/components/product/Product.vue';
import StudioPurchaseToolbar from '@/components/shop/StudioPurchaseToolbar.vue';
import { errorToMessage } from '@/utils/errors';
import api from '~/api/products';

export default {
  name: 'StudioBundledProduct',
  components: {
    Product,
    StudioPurchaseToolbar,
  },
  async setup() {
    const { $studioURL } = useNuxtApp();
    const route = useRoute();
    const bundleId = route.params.bundle_id;

    definePageMeta({
      name: 'studio-bundled-product',
      middleware: (to) => {
        if(to.name !== 'studio-bundled-product') return;
        return {
          name: 'bundle-studio-product-about',
          params: to.params,
        }
      },
      isStudio: true,
      hideMobileNav: true,
    });

    try {
      const { data: productBasic } = await useAsyncData('productBasic', () => api.getProductBasic($studioURL, bundleId))

      const seoMeta = {
        ogTitle: `${productBasic.value.product_name} | ${productBasic.value.studio_name}`,
      }
      if(productBasic.value?.cover_file?.image_url) {
        seoMeta.ogImage = productBasic.value.cover_file?.image_url
      }

      useSeoMeta(seoMeta)
    } catch (error) {
      console.error(error);
    }
  },
  data() {
    return {
      review: true,
      isPurchasing: false,
      showFullActions: true,
      isLoading: false,
      bundle: null,
    };
  },
  computed: {
    studioURL() {
      return this.$studioURL;
    },
  },
  async mounted() {
    this.loadBundle();
    this.trackProductView();
  },
  methods: {
    async loadBundle() {
      try {
        this.isLoading = true;
        const result = await Promise.all([
          useProductStore().fetchProductDetail({
            studioURL: this.studioURL,
            productId: this.$route.params.bundle_id,
          }),
          useProductStore().getProductDetail({
            studioURL: this.studioURL,
            productId: this.$route.params.product_id,
          })
        ])
        this.bundle = result[0]
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load product',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      } finally {
        this.isLoading = false;
      }
    },
    async trackProductView() {
      try {
        await useProductStore().trackProductView({
          studioURL: this.$studioURL,
          productId: this.$route.params.product_id,
        });
      } catch (e) {
        console.log('Error tracking product view');
      }
    }
  },
};
</script>
